import React, { useEffect, useState } from 'react';
import axios from 'axios';

function LogsIA() {
  const [logs, setLogs] = useState([]);
  const [modelo, setModelo] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [carregando, setCarregando] = useState(false);


  const formatarDataBrasileira = (dataISO) => {
  if (!dataISO) return '';
  const data = new Date(dataISO);
  return data.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

  const buscarLogs = async () => {
  setCarregando(true);
  const usuario_id = localStorage.getItem('usuario_id'); // pega o id

  try {
        const res = await axios.post(
          'https://welaunchyou.com.br/crm-wly/api/openai/logs_respostas.php', {
            modelo,
            data_inicio: dataInicio,
            data_fim: dataFim
          },
          {
            withCredentials: true
          }
        );


    const data = res.data;
    console.log('📦 Resposta da API:', data);

    if (data.success && Array.isArray(data.logs)) {
      setLogs(data.logs);
    } else {
      console.warn('⚠️ Resposta inesperada da API:', data);
      setLogs([]);
    }
  } catch (err) {
    console.error('❌ Erro ao carregar logs da IA:', err);
    setLogs([]);
  } finally {
    setCarregando(false);
  }
};

  useEffect(() => {
    buscarLogs();
  }, []);

  return (
  <div className="p-4 max-w-5xl mx-auto">
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '40px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: '14px' }}>Início:</label>
        <input
          type="date"
          value={dataInicio}
          onChange={(e) => setDataInicio(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '200px' }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: '14px' }}>Fim:</label>
        <input
          type="date"
          value={dataFim}
          onChange={(e) => setDataFim(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '200px' }}
        />
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <button
          onClick={buscarLogs}
          style={{ backgroundColor: '#2563eb', color: 'white', padding: '10px 20px', borderRadius: '6px', width: '200px', marginTop: '15px'  }}
        >
          Filtrar
        </button>
      </div>
    </div>

    {carregando ? (
      <p>Carregando logs...</p>
    ) : Array.isArray(logs) && logs.length === 0 ? (
      <p>Nenhum log encontrado.</p>
    ) : (
      <div className="space-y-6">
        {logs.map((log) => (
          <div key={log.id} className="border rounded p-4 shadow">
            <p><strong>Lead:</strong> {log.nome_lead || '---'}</p>
            <p><strong>Data:</strong>  {formatarDataBrasileira(log.data_envio)}</p>
            <p className="mt-2"><strong>Pergunta:</strong><br />{log.mensagem_usuario}</p>
            <p className="mt-2"><strong>Resposta:</strong><br />{log.mensagem_ia}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);

}

export default LogsIA;
